class MasterdataController implements ng.IComponentController {
    
    constructor() {
        'ngInject';
    }
}

export const masterdataComponent : ng.IComponentOptions = {
    controller : MasterdataController,
    template : require('./masterdata.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/settings/masterdata/masterdata.component.ts